import React from 'react'
import Layout from '../../Layout.jsx';
import '../../CustomAssets/Css/Pages/SubPages/CompanyDoc.css';

import EFROOT_Card from '../../CustomAssets/Images/LegalDocuments/EFROOT_Card.jpg';
import EFROOT_PanCard from '../../CustomAssets/Images/LegalDocuments/EFROOT_PanCard.png';
import RKM_Card from '../../CustomAssets/Images/LegalDocuments/RKM_Card.jpg';
import RKM_PanCard from '../../CustomAssets/Images/LegalDocuments/RKM_PanCard.jpg';

export default function CompanyDoc() {
return (
<>
<Layout>

<section className="banner org_clr">
<div className="container ">
<div className="row gy-4 gy-sm-0 align-items-center justifyCenter">
<div className="col-12  col-sm-12">
<div className="banner__content">
<h1 className="banner__title display-4 wow fadeInLeft textCenter" data-wow-duration="0.8s">Company Doc</h1>
</div>
</div>
</div>
</div>
</section>

<div className="tp-page-area sec-mar">
<div className="container-fluid custom-container">
<div className="row">
<div className="col-xl-12">
<div className="tp-page-content">
<div className="tp-page-post">
<div data-elementor-type="wp-page" data-elementor-id="47" className="elementor elementor-47">

<div className="elementor-element elementor-element-3183344" data-id="3183344"
data-element_type="container">
<div className="elementor-element elementor-element-ebda982 elementor-widget elementor-widget-tp-choose"
    data-id="ebda982" data-element_type="widget" data-widget_type="tp-choose.default">
    <div className="elementor-widget-container">


        <section className="choose-us ">

            <section className="company-documents">
                <div className="container">
                    <div className="row gy-5 gy-lg-0 justify-content-between align-items-center section">

                        {/* Image Section with Downloads */}
                        <div className="col-12 col-md-8 col-lg-5 mx-auto mx-lg-0 order-1 order-lg-0">
                            <div className='row'>



                                <div className='col-md-12 lgDocDiv'>
                                    <h5>EFOORT CERTIFICATE OF INCORPORATION AND PANCARD</h5>
                                    <div className='row'>

                                        <div className='col-md-6'>
                                            <div className="document-preview-wrapper">
                                                <a href={EFROOT_Card} download className="download-link">
                                                    <img
                                                        src={EFROOT_Card}
                                                        alt="Document"
                                                        className="uniform-image preview-image"
                                                    />
                                                    <div className="overlay-text">Download Document</div>
                                                </a>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className="document-preview-wrapper">
                                                <a href={EFROOT_PanCard} download className="download-link">
                                                    <img
                                                        src={EFROOT_PanCard}
                                                        alt="Document"
                                                        className="uniform-image preview-image"
                                                    />
                                                    <div className="overlay-text">Download Document</div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-12 lgDocDiv'>
                                    <h5>RKM CERTIFICATE OF INCORPORATION AND PANCARD</h5>
                                    <div className='row'>


                                        <div className='col-md-6'>
                                            <div className="document-preview-wrapper">
                                                <a href={RKM_Card} download className="download-link">
                                                    <img
                                                        src={RKM_Card}
                                                        alt="Document"
                                                        className="uniform-image preview-image"
                                                    />
                                                    <div className="overlay-text">Download Document</div>
                                                </a>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className="document-preview-wrapper">
                                                <a href={RKM_PanCard} download className="download-link">
                                                    <img
                                                        src={RKM_PanCard}
                                                        alt="Document"
                                                        className="uniform-image preview-image"
                                                    />
                                                    <div className="overlay-text">Download Document</div>
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>


                        </div>

                        {/* Content Section */}
                        <div className="col-12 col-lg-7 col-xxl-6">
                            <div className="section__content ms-lg-4 ms-xl-0">
                                <span
                                    className="sub-title section__content-sub-title headingFour wow fadeInDown txt_clr"
                                    data-wow-duration="0.8s"
                                >
                                    <img
                                        decoding="async"
                                        src="theme_assets/assets/themes/assets/images/title_vector.png"
                                        alt="Image"
                                    />
                                    Legal Documents
                                </span>
                                <h2
                                    className="title section__content-title wow fadeInUp"
                                    data-wow-duration="0.8s"
                                >
                                    Access and Download Essential Company Legal Documents
                                </h2>
                                <p
                                    className="xlr pp section__content-text wow fadeInDown"
                                    data-wow-duration="0.8s"
                                >
                                    Ensure transparency and compliance with quick access to legally vetted documents.
                                    Download certificates, agreements, and essential paperwork required for onboarding or due diligence.
                                </p>

                                <div className="section__content-inner wow fadeInUp" data-wow-duration="0.8s">
                                    <ul className="cus_list doc_cus_list">
                                        <li className="headingFive">Legally Compliant Formats</li>
                                        <li className="headingFive">Verified and Up-to-Date Records</li>
                                        <li className="headingFive">Ready for Onboarding or Audit</li>
                                        <li className="headingFive">Instant PDF Downloads</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

        </section>


    </div>
</div>
</div>


</div>
</div>
</div>
</div>
</div>
</div>
</div>

</Layout>

</>
)
}
